module.exports = __webpack_public_path__ + "static/media/esther_tft.72af6453.jpg";